// Block all third-party popups on the survey page
(function () {
  var POPUP_SELECTORS = [
    '[class*="breeze"]', '[id*="breeze"]',
    '[class*="nexus"]', '[id*="nexus"]',
    '[class*="trending"]', '[id*="trending"]',
    '[class*="recently"]', '[id*="recently"]',
    '[class*="popup"]', '[class*="modal"]',
    '[class*="overlay"]', '[class*="trustoo"]',
    '[class*="klaviyo"]', '[data-form-id]',
    'klaviyo-form'
  ].join(',');

  var SAFE = ['survey-page', 'amiee-survey', 'survey-'];

  function isSurveyEl(el) {
    return SAFE.some(function (s) {
      return (el.className && el.className.includes && el.className.includes(s)) ||
             (el.id && el.id.includes(s));
    });
  }

  function blockPopups() {
    try {
      document.querySelectorAll(POPUP_SELECTORS).forEach(function (el) {
        if (!isSurveyEl(el)) el.style.setProperty('display', 'none', 'important');
      });
    } catch (e) {}
  }

  blockPopups();

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (!isSurveyEl(node) && node.matches && node.matches(POPUP_SELECTORS)) {
          node.style.setProperty('display', 'none', 'important');
        }
        // Also check children of added nodes
        if (node.querySelectorAll) {
          node.querySelectorAll(POPUP_SELECTORS).forEach(function (el) {
            if (!isSurveyEl(el)) el.style.setProperty('display', 'none', 'important');
          });
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

(function () {
  var form = document.getElementById('amiee-survey');
  if (!form) return;

  var webhookUrl = form.dataset.webhook;
  var steps = Array.from(form.querySelectorAll('.survey-step'));
  var totalSteps = steps.length;
  var currentStep = 0;
  var answers = {};

  var progressFill = document.getElementById('survey-progress-fill');
  var progressLabel = document.getElementById('survey-progress-label');
  var progressBar = document.getElementById('survey-progress-bar');
  var introEl = document.getElementById('survey-intro');
  var thankyouEl = document.getElementById('survey-thankyou');
  var submittingEl = document.getElementById('survey-submitting');
  var errorEl = document.getElementById('survey-error');

  // Start survey
  var startBtn = document.getElementById('survey-start-btn');
  if (startBtn) {
    startBtn.addEventListener('click', function () {
      introEl.style.display = 'none';
      progressBar.style.display = 'block';
      showStep(0);
    });
  }

  function updateProgress(index) {
    var pct = Math.round(((index) / totalSteps) * 100);
    progressFill.style.width = pct + '%';
    progressLabel.textContent = 'Question ' + (index + 1) + ' of ' + totalSteps;
  }

  function showStep(index) {
    steps.forEach(function (s) {
      s.classList.remove('active', 'visible');
    });
    var step = steps[index];
    step.classList.add('active');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        step.classList.add('visible');
      });
    });
    currentStep = index;
    updateProgress(index);
    updateNextBtn(step);
  }

  function contactFieldsFilled(step) {
    return Array.from(step.querySelectorAll('.survey-field__input')).every(function (inp) {
      return inp.value.trim() !== '';
    });
  }

  function updateNextBtn(step) {
    var btn = step.querySelector('.survey-btn-next');
    if (!btn) return;
    var qName = step.dataset.question;
    btn.disabled = qName === 'contact' ? !contactFieldsFilled(step) : !answers[qName];
  }

  // Option click: record answer and enable next button
  form.addEventListener('change', function (e) {
    if (e.target.type !== 'radio') return;
    var step = e.target.closest('.survey-step');
    var qName = step.dataset.question;
    answers[qName] = e.target.value;
    updateNextBtn(step);
  });

  // Contact field input: enable next button when all filled
  form.addEventListener('input', function (e) {
    if (!e.target.classList.contains('survey-field__input')) return;
    var step = e.target.closest('.survey-step');
    updateNextBtn(step);
  });

  // Next button
  form.addEventListener('click', function (e) {
    var btn = e.target.closest('.survey-btn-next');
    if (!btn) return;
    var step = btn.closest('.survey-step');
    var qName = step.dataset.question;
    if (qName === 'contact') {
      if (!contactFieldsFilled(step)) return;
    } else {
      if (!answers[qName]) return;
    }

    var nextIndex = currentStep + 1;
    if (nextIndex < totalSteps) {
      showStep(nextIndex);
    } else {
      submitSurvey();
    }
  });

  // Back button
  form.addEventListener('click', function (e) {
    var btn = e.target.closest('.survey-btn-back');
    if (!btn) return;
    if (currentStep > 0) {
      showStep(currentStep - 1);
    }
  });

  function submitSurvey() {
    steps.forEach(function (s) { s.classList.remove('active', 'visible'); });
    progressBar.style.display = 'none';
    submittingEl.classList.add('active');

    var params = new URLSearchParams(window.location.search);
    var payload = {
      name:  (form.querySelector('#survey-name')  || {}).value || '',
      email: (form.querySelector('#survey-email') || {}).value || '',
      phone: (form.querySelector('#survey-phone') || {}).value || '',
      q1: answers.q1 || '',
      q2: answers.q2 || '',
      q3: answers.q3 || '',
      q4: answers.q4 || '',
      q5: answers.q5 || '',
      submitted_at: new Date().toISOString(),
      source: window.location.href,
      utm_source:   params.get('utm_source')   || '',
      utm_medium:   params.get('utm_medium')   || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term:     params.get('utm_term')     || '',
      utm_content:  params.get('utm_content')  || '',
      fbclid:  params.get('fbclid')  || '',
      gclid:   params.get('gclid')   || '',
      ttclid:  params.get('ttclid')  || '',
      msclkid: params.get('msclkid') || ''
    };

    if (!webhookUrl) {
      showThankyou();
      return;
    }

    fetch(webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function () {
        showThankyou();
      })
      .catch(function () {
        // Still show thank you — don't block user on network error
        showThankyou();
      });
  }

  function showThankyou() {
    submittingEl.classList.remove('active');
    thankyouEl.style.display = 'block';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        thankyouEl.classList.add('visible');
      });
    });
    // Fire Meta Pixel Lead event
    if (typeof fbq === 'function') {
      fbq('track', 'Lead');
    }
  }
})();

// Coupon copy button
document.addEventListener('DOMContentLoaded', function () {
  var copyBtn = document.getElementById('survey-copy-code');
  if (!copyBtn) return;
  copyBtn.addEventListener('click', function () {
    var code = copyBtn.dataset.code;
    navigator.clipboard.writeText(code).then(function () {
      copyBtn.classList.add('copied');
      setTimeout(function () { copyBtn.classList.remove('copied'); }, 2000);
    }).catch(function () {
      // Fallback for older browsers
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      copyBtn.classList.add('copied');
      setTimeout(function () { copyBtn.classList.remove('copied'); }, 2000);
    });
  });
});
